<template>
    <div v-if="mostrarMenu" class="mt-2">
        <h4 class="heading-1">
            <span>GESCON</span>
        </h4>
        <b-list-group>
            <relatorio-faturamento-servicos></relatorio-faturamento-servicos>
            <relatorio-consumo-itens-contrato></relatorio-consumo-itens-contrato>
        </b-list-group>
    </div>
</template>

<script>
import RelatorioFaturamentoServicos from './RelatorioFaturamentoServicos'
import RelatorioConsumoItensContrato from './RelatorioConsumoItensContrato'

export default {
    components: {
        RelatorioFaturamentoServicos,
        RelatorioConsumoItensContrato
    },

    computed: {
        mostrarMenu() {
            return true
        }
    }
}
</script>
